export const FORM_FIELDS = {
  PHONE: 'phone',
  PIN: 'pin',
} as const;

export type FormValues = {
  phone: string;
  pin?: string;
};
